import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";import {
  generateUniqueNumber,
  updateObjectInArray,
} from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import TaxRateForm from "../../../components/forms/setup/taxRates/TaxRateForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";

export function TaxRatesViewModel(addSnackbar, logout) {
  const [loading, setLoading] = useState(false);
  const [taxRates, setTaxRates] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getTaxRates = async function (search, page) {
    setLoading(true);

    let callResult = await makeGetApiCall(
      `taxRates?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setTaxRates(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const createTaxRate = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("taxRates/create", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getTaxRates("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateTaxRate = async function (values, index) {
    let callResult = await makePutApiCall(`taxRates/${values.id}`, values);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...taxRates.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setTaxRates({ ...taxRates, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddTaxRatesSlideOver = (isEdit, tax, index) => {
    setSlideOver({
      childComponent: (
        <TaxRateForm
          tax={tax}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateTaxRate(payload, index) : createTaxRate(payload)
          }
          title={isEdit ? `Update ${tax.name}` : "Add new tax rate"}
          inProgress={false}
        />
      ),
      open: true,
    });
  };

  const deleteTaxRate = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteTaxRate/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = taxRates.data.filter((item) => item.id !== id);
      setTaxRates({ ...taxRates, data: newItems });

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteTaxRate = function (tax, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteTaxRate(tax.id, index)}
          message={`Are you sure you want to delete ${tax.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddTaxRatesSlideOver,
    getTaxRates,
    loading,
    taxRates,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteTaxRate,
  };
}
